import React from "react";
import HOC from "../../../components/HOC";
import AddTransfer from "../../../components/screen/centralWarehouse/transfer/AddTransfer";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const AddTransferPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="New Transfer"
        mainComponent={
          <ThemeProvider theme={theme}>
            <AddTransfer />
          </ThemeProvider>
        }
        pageRole={35}
      />
    </div>
  );
};

export default HOC(AddTransferPage);
